import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { sv } from 'date-fns/locale';
import { api } from "../../api";

function EditModal({ type, item, onClose, onUpdate }) {
  const isVehicle = type === 'vehicle';
  const itemId = item?._id || item?.id;

  // VEHICLE
  const [vLast, setVLast] = useState(new Date());
  const [vNext, setVNext] = useState(new Date());

  // EMPLOYEE
  const [ssgApplied, setSsgApplied] = useState(null);
  const [ssgExpires, setSsgExpires] = useState(null);
  const [lkabApplied, setLkabApplied] = useState(null);
  const [lkabExpires, setLkabExpires] = useState(null);

  // Förnyelse-val (checkboxar)
  const [renewSSG, setRenewSSG] = useState(false);
  const [renewLKAB, setRenewLKAB] = useState(false);

  useEffect(() => {
    if (isVehicle) {
      setVLast(item?.inspectionDate ? new Date(item.inspectionDate) : new Date());
      setVNext(item?.inspectionExpires ? new Date(item.inspectionExpires) : new Date());
    } else {
      setSsgApplied(item?.ssgApplied ? new Date(item.ssgApplied) : null);
      setSsgExpires(item?.ssgExpires ? new Date(item.ssgExpires) : null);
      setLkabApplied(item?.lkabApplied ? new Date(item.lkabApplied) : null);
      setLkabExpires(item?.lkabExpires ? new Date(item.lkabExpires) : null);
      setRenewSSG(false);
      setRenewLKAB(false);
    }
  }, [item, isVehicle]);

  const guardNoId = () => {
    if (!itemId) {
      console.error('Saknar id på item:', item);
      alert('Objektet saknar ID och kan inte uppdateras.');
      return true;
    }
    return false;
  };

  const calcVehicleNext = (fromDate) => {
    const d = new Date(fromDate || new Date());
    d.setMonth(d.getMonth() + 12);
    d.setDate(new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate()); // sista dagen i månaden
    return d;
  };

  const plusOneYear = (from) => {
    const d = new Date(from || new Date());
    d.setFullYear(d.getFullYear() + 1);
    return d;
  };

  // Fyll i förslag – spara INTE här
  const handleRenew = () => {
  if (isVehicle) {
    // Räkna nästa från "Senaste besiktning" (fallback: idag)
    const base = vLast || new Date();
    const next = new Date(base);
    next.setMonth(next.getMonth() + 12);
    // sista dagen i månaden
    next.setDate(new Date(next.getFullYear(), next.getMonth() + 1, 0).getDate());
    setVNext(next);           // <-- uppdaterar fältet direkt i modalen
    return;                   // tryck "Spara" för att persistera
  }
    const today = new Date();
    if (renewSSG) {
      if (ssgApplied != null) {
        setSsgExpires(plusOneYear(ssgApplied));
      } else {
        setSsgExpires(plusOneYear(today));
      }

    }
    if (renewLKAB) {
      if (lkabApplied != null) {
        setLkabExpires(plusOneYear(lkabApplied));
      } else {
        setLkabExpires(plusOneYear(today));
      }
    }
    // Användaren trycker "Spara" för att faktiskt persistera
  };

  // Spara exakt vad som står i formuläret
  const handleSave = async () => {
    if (guardNoId()) return;
    try {
      if (isVehicle) {
        await api.put(`/vehicles/${itemId}`, {
          inspectionDate: vLast,
          inspectionExpires: vNext,
        });
      } else {
        const payload = {};
        if (ssgApplied) payload.ssgApplied = ssgApplied;
        if (ssgExpires) payload.ssgExpired = ssgExpires;
        if (lkabApplied) payload.lkabApplied = lkabApplied;
        if (lkabExpires) payload.lkabExpired = lkabExpires;
        if (itemId) payload.itemId = itemId;
        await api.patch(`/auth/education`, payload);
      }
      await onUpdate();
      onClose();
    } catch (err) {
      console.error('Fel vid sparning:', err);
      alert('Något gick fel vid sparning.');
    }
  };

  const handleDelete = async () => {
    if (guardNoId()) return;
    try {
      await api.delete(`/${type}s/${itemId}`);
      await onUpdate();
      onClose();
    } catch (err) {
      console.error('Fel vid borttagning:', err);
      alert('Kunde inte ta bort objektet.');
    }
  };

  return (
    <Modal show onHide={onClose} fullscreen="sm-down" scrollable>
      <Modal.Header closeButton>
        <Modal.Title>
          Redigera {isVehicle ? `Fordon – ${item?.regNr || ''}` : `Anställd – ${item?.firstName || ''}`}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {isVehicle ? (
          <>
            <Row className="mb-3">
              <Col md={6}>
                <Form.Label>Senaste besiktning</Form.Label>
                <DatePicker
                  selected={vLast}
                  onChange={setVLast}
                  className="form-control"
                  dateFormat="dd/MM/yyyy"
                  locale={sv}
                  calendarStartDay={1}
                  showWeekNumbers
                                      withPortal
                    popperPlacement="bottom-start"   
                />
              </Col>
              <Col md={6}>
                <Form.Label>Nästa (utgångsdatum)</Form.Label>
                <DatePicker
                  selected={vNext}
                  onChange={setVNext}
                  className="form-control"
                  dateFormat="dd/MM/yyyy"
                  locale={sv}
                  calendarStartDay={1}
                  showWeekNumbers
                    withPortal
                    popperPlacement="bottom-start"
                />

              </Col>
            </Row>
          </>
        ) : (
          <>
            <h6>SSG</h6>
            <Form.Check
              type="checkbox"
              label="Fyll i +1 år vid Förnya"
              checked={renewSSG}
              onChange={(e) => setRenewSSG(e.target.checked)}
              className="mb-2"
            />
            <Row className="mb-3">
              <Col md={6}>
                <Form.Label>Senaste ansökan</Form.Label>
                <DatePicker
                  selected={ssgApplied}
                  onChange={setSsgApplied}
                  className="form-control"
                  dateFormat="dd/MM/yyyy"
                  locale={sv}
                  calendarStartDay={1}
                  isClearable
                    withPortal
                    popperPlacement="bottom-start"    
                />
              </Col>
              <Col md={6}>
                <Form.Label>Utgångsdatum</Form.Label>
                <DatePicker
                  selected={ssgExpires}
                  onChange={setSsgExpires}
                  className="form-control"
                  dateFormat="dd/MM/yyyy"
                  locale={sv}
                  calendarStartDay={1}
                  isClearable
                                      withPortal
                    popperPlacement="bottom-start"   
                />
              </Col>
            </Row>

            <h6>LKAB</h6>
            <Form.Check
              type="checkbox"
              label="Fyll i +1 år vid Förnya"
              checked={renewLKAB}
              onChange={(e) => setRenewLKAB(e.target.checked)}
              className="mb-2"
            />
            <Row>
              <Col md={6}>
                <Form.Label>Senaste ansökan</Form.Label>
                <DatePicker
                  selected={lkabApplied}
                  onChange={setLkabApplied}
                  className="form-control"
                  dateFormat="dd/MM/yyyy"
                  locale={sv}
                  calendarStartDay={1}
                  isClearable
                                      withPortal
                    popperPlacement="bottom-start"   
                />
              </Col>
              <Col md={6}>
                <Form.Label>Utgångsdatum</Form.Label>
                <DatePicker
                  selected={lkabExpires}
                  onChange={setLkabExpires}
                  className="form-control"
                  dateFormat="dd/MM/yyyy"
                  locale={sv}
                  calendarStartDay={1}
                  isClearable
                                      withPortal
                    popperPlacement="bottom-start"   
                />
              </Col>
            </Row>
            <div className="text-muted small mt-2">
              Tips: Använd <em>Förnya</em> för att auto-fylla datum enligt reglerna, och tryck sen <strong>Spara</strong>.
            </div>
          </>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleRenew}>Förnya</Button>
        <Button variant="danger" onClick={handleDelete}>Ta bort</Button>
        <Button variant="primary" onClick={handleSave}>Spara</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default EditModal;
